import React, { useState } from 'react';

import UpArrow from '../../../../../assets/svg/UpArrow';
import DownArrow from '../../../../../assets/svg/DownArrow';
import useWidth from '../../../../hooks/useWidth';
import { useHistory } from 'react-router-dom';
import BackArrow from '../../../../../assets/svg/BackArrow';
import { USER_PROFILE } from '../../../../utils/storageWeb';

const topicData = [
    {
        id: 1,
        title: '',
        sections: [
            {
                id: 1,
                title: 'How to request a mentor?',
                subSections: [
                    {
                        description: 'Click on request a mentor tab',
                        image: '/assets/help/requestMentor/rm_01.png',
                    },
                    {
                        description:
                            'If you have completed more than 10 challenges, you will be able to select specialisation area and describe what you are looking for.',
                        image: '/assets/help/requestMentor/rm_02.png',
                    },
                    {
                        description:
                            'Once you submit the request, you will get a message acknowledging your request. And upon reviewing your request, the BRIDGE team will connect you with a mentor via email.',
                        image: '/assets/help/requestMentor/rm_03.png',
                    },
                ],
            },
            {
                id: 2,
                title: 'Why I cannot request a mentor?',
                subSections: [
                    {
                        description: 'Click on request a mentor tab',
                        image: '/assets/help/requestMentor/rm_04.png',
                    },
                    {
                        description:
                            'If you have not completed more than 10 challenges you will not be able to request a mentor. You will get a message asking to complete up to 10 challenges to request a mentor.',
                        image: '/assets/help/requestMentor/rm_05.png',
                    },
                ],
            },
        ],
    },
];

const Index = () => {
    const [selectedSection, setSelectedSection] = useState(null);
    const [isExpanded, setIsExpanded] = useState(false);
    const viewPortWidth = useWidth();
    const history = useHistory();
    const profile = JSON.parse(localStorage.getItem(USER_PROFILE));

    const handleAccordion = (index: number) => {
        if (selectedSection === index) {
            setSelectedSection(null);
            setIsExpanded(false);
        } else {
            setSelectedSection(index);
            setIsExpanded(true);
        }
    };

    return (
        <>
            {viewPortWidth > 1023 ? (
                <div className="mx-10 md:mx-5 md:ml-14 lg:ml-72 lg:pl-3.5 lg:pt-2 md:mt-14 lg:mb-28">
                    <div
                        className="flex mb-5 cursor-pointer"
                        onClick={() => history.push(`/dashBoard/help`)}
                    >
                        <BackArrow size="27" />
                        <p className="text-base ml-2 font-semibold  hover:underline">Back</p>
                    </div>
                    <div className="mb-6 border-b-2 border-purple-75">
                        <div className="text-2xl-2 leading-10 font-manrope font-bold mb-2">
                            Request a Mentor
                        </div>
                        <div className="text-base font-normal mb-7">
                            How do you request a mentor?
                        </div>
                    </div>
                    {topicData.map(section => (
                        <div key={section.id} className="mb-4">
                            <div className="text-xl font-bold font-manrope mb-3">
                                {section.title}
                            </div>
                            {section.sections.map(subSection => (
                                <div
                                    key={subSection.id}
                                    style={{ borderWidth: 1 }}
                                    className={`rounded mb-3 
                        ${
                            selectedSection === subSection.id && isExpanded
                                ? 'border-purple-50 bg-purple-85'
                                : 'border-gray-300 bg-transparent'
                        }`}
                                >
                                    <div
                                        className={`px-11 py-8 relative flex items-center text-base cursor-pointer 
                            ${
                                selectedSection === subSection.id && isExpanded
                                    ? 'font-bold text-purple-950'
                                    : 'font-normal'
                            }`}
                                        onClick={() => handleAccordion(subSection.id)}
                                    >
                                        {subSection.title}
                                        <div className="absolute right-7">
                                            {selectedSection === subSection.id && isExpanded ? (
                                                <UpArrow />
                                            ) : (
                                                <DownArrow />
                                            )}
                                        </div>
                                    </div>
                                    {selectedSection === subSection.id &&
                                        isExpanded &&
                                        subSection.subSections.map((item, subIndex) => (
                                            <div
                                                key={subIndex}
                                                className="flex justify-between items-center gap-10 p-6 pl-11 bg-purple-85 border-t-2 border-purple-75"
                                            >
                                                <div
                                                    className={`${
                                                        item.image ? `w-8/12` : `w-full`
                                                    } text-sm font-normal`}
                                                >
                                                    {item.description}
                                                </div>
                                                {item.image && (
                                                    <img
                                                        className="max-w-sm h-full object-contain"
                                                        src={item.image}
                                                        alt="FAQ step's image"
                                                    />
                                                )}
                                            </div>
                                        ))}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            ) : (
                <div className="px-4 mt-4">
                    <div className="flex mb-3 mt-1 cursor-pointer" onClick={() => history.goBack()}>
                        <BackArrow size="27" />
                        <p className="text-base ml-2 font-semibold">Back</p>
                    </div>
                    <div className="mb-6 border-b-2 border-purple-75">
                        <div className="text-xl leading-10 font-manrope font-bold mb-2">
                            Request a Mentor
                        </div>
                        <div className="text-xs font-normal mb-7">How do you request a mentor?</div>
                    </div>
                    {topicData.map(section => (
                        <div key={section.id} className="mb-8">
                            <div className="text-lg font-bold font-manrope mb-3">
                                {section.title}
                            </div>
                            {section.sections.map(subSection => (
                                <div
                                    key={subSection.id}
                                    style={{ borderWidth: 1 }}
                                    className={`rounded mb-3 
                            ${
                                selectedSection === subSection.id && isExpanded
                                    ? 'border-purple-50 bg-purple-85'
                                    : 'border-gray-300 bg-transparent'
                            }`}
                                >
                                    <div
                                        className={`px-11 py-8 w-full relative flex items-center text-xs cursor-pointer 
                                ${
                                    selectedSection === subSection.id && isExpanded
                                        ? 'font-bold text-purple-950'
                                        : 'font-normal'
                                }`}
                                        onClick={() => handleAccordion(subSection.id)}
                                    >
                                        <span className="w-11/12">{subSection.title}</span>
                                        <div className="absolute right-7">
                                            {selectedSection === subSection.id && isExpanded ? (
                                                <UpArrow />
                                            ) : (
                                                <DownArrow />
                                            )}
                                        </div>
                                    </div>
                                    {selectedSection === subSection.id &&
                                        isExpanded &&
                                        subSection.subSections.map((item, subIndex) => (
                                            <div
                                                key={subIndex}
                                                className="flex flex-col justify-between items-center gap-y-4 py-5 px-11 bg-purple-85 border-t-2 border-purple-75"
                                            >
                                                {item.image && (
                                                    <img
                                                        className="w-full h-full object-contain"
                                                        src={item.image}
                                                        alt="FAQ step's image"
                                                    />
                                                )}
                                                <div className={`w-full text-xs font-normal`}>
                                                    {item.description}
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default Index;
